import * as React from 'react';
import { Schema, SchemaField } from '../../../types/Metadata';
import { NodeType } from '../../../enums/NodeType';
import { useSelector } from '../../../utils/useSelector';
import { getSchema, isAuditType } from '../../../utils';
import { TreeFieldUtils } from '../../../utils/treeFieldUtils';
import { ItemFieldCard } from './itemFieldCard';
import { findOne } from 'rcd-cpp-workspace/utils/array';
import { ItemFieldParentCard } from './itemFieldParentCard';
import { ItemGroupCard } from './ItemGroupCard';

interface Props {
  field: SchemaField;
  schemaForm?: Schema;
  onMove?: (index1: number, index2: number) => void;
  index: number;
  children?: React.ReactNode;
}

export const ItemFieldCardWrapper = (p: Props) => {
  const fields = useSelector(s => s.schemaModal?.fields);
  const schemas = useSelector(s => s.planning?.selectedWorkspace?.schemas);
  let pField = p.field;
  if (p.schemaForm) {
    const f = findOne(fields, { field: pField.field });
    if (f) pField = { ...f, ...pField };
  }

  const { field, relationType, isSystemField, isInherited } = pField;
  const isDisabled =
    isInherited ||
    isSystemField ||
    field == 'isActive' ||
    isAuditType(relationType);

  if (pField.dataType == 'group') {
    return <ItemGroupCard {...p} field={pField} isDisabled={isDisabled} />;
  }

  const treeFields = React.useMemo(() => {
    const schema = getSchema(schemas, NodeType.Item);
    const treeFieldSettings = TreeFieldUtils.getTreeSetting(
      schema,
      p.field,
      schemas,
      true
    );
    if (!treeFieldSettings) return null;
    const treeFields = treeFieldSettings.settings
      ?.map(f => {
        const field = findOne(fields, { field: f?.field?.field });
        if (p.schemaForm) {
          const schemaFormField = findOne(p.schemaForm.props?.fields, {
            field: f?.field?.field
          });
          if (!schemaFormField) return null;
          return {
            ...field,
            ...schemaFormField,
            name: field.name,
            description: field.description
          };
        } else {
          return field;
        }
      })
      .filter(Boolean);
    if (treeFields.length == 1) return null;
    return treeFields;
  }, [schemas, p.field, fields, p.schemaForm]);

  if (treeFields != null) {
    if (!treeFields.length) return null;
    return (
      <ItemFieldParentCard
        {...p}
        field={pField}
        treeFields={treeFields}
        isDisabled={isDisabled}
      />
    );
  } else {
    return <ItemFieldCard {...p} field={pField} isDisabled={isDisabled} />;
  }
};
